import { useState } from "react";
import { careEnvironment, getQueryClient } from "@akina/config";
import { loggerService, IntlProvider } from "@akina/infra";
import {
  useLocaleCopyStore,
  useLocaleStore,
  ToastProvider,
  ErrorBoundary,
  MaintenanceGuard,
  LocaleBootstrapper,
  useToasts,
} from "@akina/presentation";
import { flattenMessages } from "@akina/utils";
import { QueryClientProvider } from "@tanstack/react-query";
import { Providers } from "./Providers";

export function AppProvider() {
  const { addToast } = useToasts();
  const { locale } = useLocaleStore();
  const { localeCopy } = useLocaleCopyStore();

  const messages = flattenMessages(localeCopy);
  const [queryClient] = useState(() =>
    getQueryClient({
      addToast,
      log: loggerService.info,
    }),
  );

  return (
    <ErrorBoundary env={careEnvironment.environment}>
      <IntlProvider onError={() => null} locale={locale} messages={messages}>
        <QueryClientProvider client={queryClient}>
          <LocaleBootstrapper slugPrefixes={["care", "shared"]} />
          <MaintenanceGuard>
            <ToastProvider>
              <Providers />
            </ToastProvider>
          </MaintenanceGuard>
        </QueryClientProvider>
      </IntlProvider>
    </ErrorBoundary>
  );
}
